import _sfc_main from "./Dropdown.vue2.js";
/* empty css              */
import _export_sfc from "../../_virtual/_plugin-vue_export-helper.js";
const Dropdown = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-43d25c22"]]);
export {
  Dropdown as default
};
//# sourceMappingURL=Dropdown.vue.js.map
